export function bufToB64Url(buf: ArrayBuffer): string {
  const b64 = btoa(String.fromCharCode(...new Uint8Array(buf)));
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

export function b64UrlToBuf(b64url: string): ArrayBuffer {
  const pad = '='.repeat((4 - (b64url.length % 4)) % 4);
  const b64 = (b64url + pad).replace(/-/g, '+').replace(/_/g, '/');
  const str = atob(b64);
  const bytes = new Uint8Array(str.length);
  for (let i = 0; i < str.length; i++) bytes[i] = str.charCodeAt(i);
  return bytes.buffer;
}

export function credToJSON(cred: any) {
  if (!cred) return cred;
  return {
    id: cred.id,
    type: cred.type,
    rawId: bufToB64Url(cred.rawId),
    response: {
      attestationObject: cred.response.attestationObject
        ? bufToB64Url(cred.response.attestationObject)
        : undefined,
      clientDataJSON: cred.response.clientDataJSON
        ? bufToB64Url(cred.response.clientDataJSON)
        : undefined,
      authenticatorData: cred.response.authenticatorData
        ? bufToB64Url(cred.response.authenticatorData)
        : undefined,
      signature: cred.response.signature
        ? bufToB64Url(cred.response.signature)
        : undefined,
      userHandle: cred.response.userHandle
        ? bufToB64Url(cred.response.userHandle)
        : undefined,
      transports: cred.response.getTransports ? cred.response.getTransports() : undefined,
    },
    clientExtensionResults: cred.getClientExtensionResults?.() || {},
  };
}

// Convert JSON options from server to browser-compatible by decoding base64url fields
export function toPublicKeyCredentialCreationOptions(json: any): PublicKeyCredentialCreationOptions {
  const opts: any = { ...json };
  if (opts.challenge) opts.challenge = b64UrlToBuf(opts.challenge);
  if (opts.user) {
    opts.user = { ...opts.user, id: b64UrlToBuf(opts.user.id) };
  }
  if (Array.isArray(opts.excludeCredentials)) {
    opts.excludeCredentials = opts.excludeCredentials.map((c: any) => ({
      ...c,
      id: b64UrlToBuf(c.id),
    }));
  }
  return opts as PublicKeyCredentialCreationOptions;
}

export function toPublicKeyCredentialRequestOptions(json: any): PublicKeyCredentialRequestOptions {
  const opts: any = { ...json };
  if (opts.challenge) opts.challenge = b64UrlToBuf(opts.challenge);
  if (Array.isArray(opts.allowCredentials)) {
    opts.allowCredentials = opts.allowCredentials.map((c: any) => ({
      ...c,
      id: b64UrlToBuf(c.id),
    }));
  }
  return opts as PublicKeyCredentialRequestOptions;
}
